import React, { useState, useLayoutEffect, useRef } from 'react';
import './Medicina.css';
import ContactModal from './ContactModal';
import Footer from './Footer';
import NavBar from './NavBar';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Raiz from './raiz';

gsap.registerPlugin(ScrollTrigger);

function Medicina() {
  const root = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useLayoutEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const ctx = gsap.context(() => {
      const defaultScrollConfig = {
        start: 'top 85%',
        toggleActions: 'play none none none',
      };

      // Hero animation
      const heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      heroTl
        .fromTo(
          '.hero-branch-image-medicina',
          { autoAlpha: 0, scale: 1.03 },
          { autoAlpha: 1, scale: 1, duration: 1.1, ease: 'power2.out' }
        )
        .fromTo(
          '.hero-content-medicina > *',
          { autoAlpha: 0, y: 24 },
          { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.12 },
          '-=0.6'
        );

      // Diagonal separator
      gsap.fromTo(
        '.diagonal-separator-medicina',
        { scaleX: 0, transformOrigin: 'left center' },
        {
          scaleX: 1,
          duration: 1.2,
          ease: 'expo.inOut',
          scrollTrigger: {
            trigger: '.sam-section',
            ...defaultScrollConfig,
          },
        }
      );

      // Feature items
      gsap.fromTo(
        '.feature-item',
        { autoAlpha: 0, y: 60, scale: 0.85 },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'back.out(1.2)',
          scrollTrigger: {
            trigger: '.features-grid',
            ...defaultScrollConfig,
          },
        }
      );

      // Custom items
      gsap.fromTo(
        '.custom-item',
        { autoAlpha: 0, x: -30 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.7,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.custom-grid',
            ...defaultScrollConfig,
          },
        }
      );

      // CTA button
      gsap.fromTo(
        '.cta-button',
        { autoAlpha: 0, scale: 0.8 },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.6,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: '.cta-button',
            ...defaultScrollConfig,
          },
        }
      );
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Medicina" ref={root}>
      {/* Header */}
     <NavBar />

      {/* Hero Section */}
      <section className="medicina-hero">
        <img src="/assets/fondosofwaremed1.png" alt="Branch Medical" className="hero-branch-image-medicina" />
        <div className="hero-content-medicina">
          <h1 className="hero-title-medicina">Software Médico</h1>
          <p className="hero-subtitle-medicina">
            Tecnología especializada para el sector salud
          </p>
        </div>
      </section>

      {/* SAM Section */}
      <section className="sam-section">
        <div className="diagonal-separator-medicina"></div>
        <div className="container">
          <div className="sam-header">
            <h2>SAM - Sistema de Análisis Médico</h2>
            <div className="header-line"></div>
          </div>
          <p className="sam-description">
            SAM es nuestro software propietario diseñado específicamente para revolucionar la gestión
            y análisis médico. Una solución integral que combina tecnología de vanguardia con
            años de experiencia en el sector de salud.
          </p>
          
          <div className="features-grid">
            <div className="feature-item">
              <h4>Análisis Avanzado</h4>
              <div className="feature-line"></div>
              <p>Procesamiento y análisis de datos médicos con precisión</p>
            </div>
            <div className="feature-item">
              <h4>Gestión Hospitalaria</h4>
              <div className="feature-line"></div>
              <p>Control completo de historias clínicas y pacientes</p>
            </div>
            <div className="feature-item">
              <h4>Seguridad</h4>
              <div className="feature-line"></div>
              <p>Protección total de datos sensibles y confidenciales</p>
            </div>
            <div className="feature-item">
              <h4>Tiempo Real</h4>
              <div className="feature-line"></div>
              <p>Acceso instantáneo a información crítica</p>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Solutions Section */}
      <section className="custom-section">
        <img src="/assets/fondosoftwaremed2.png" alt="Branch" className="custom-background-image" />
        <div className="container">
          <div className="custom-header">
            <h3>Tu Idea en Medicina</h3>
            <div className="header-line"></div>
          </div>
          <p className="custom-description">
            ¿Tienes una necesidad específica en tu centro médico? Desarrollamos software personalizado
            que se adapta exactamente a tus requerimientos:
          </p>
          <div className="custom-grid">
            <div className="custom-item">
              <div className="item-line"></div>
              <p>Sistemas de gestión de consultorios</p>
            </div>
            <div className="custom-item">
              <div className="item-line"></div>
              <p>Aplicaciones para seguimiento de pacientes</p>
            </div>
            <div className="custom-item">
              <div className="item-line"></div>
              <p>Integración con equipamiento médico</p>
            </div>
            <div className="custom-item">
              <div className="item-line"></div>
              <p>Plataformas de telemedicina</p>
            </div>
            <div className="custom-item">
              <div className="item-line"></div>
              <p>Software para laboratorios clínicos</p>
            </div>
          </div>
          <Raiz  onClick={() => setIsModalOpen(true)} text='Cuéntanos tu proyectos' />                                
        </div>
      </section>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      <Footer />
    </div>
  );
}

export default Medicina;
